var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"1"}},[_c(_setup.BackButton,{on:{"click":function($event){return _vm.$emit('goBackClicked')}}},[_vm._v(" Back To Drafts ")])],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"5"}},[_c('v-tabs',{attrs:{"show-arrows":""}},[_c('v-tabs-slider',{attrs:{"color":"secondary"}}),_c('v-tab',{staticClass:"text-none"},[_vm._v("Building Plan Details")])],1)],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"5"}},[_c('div',[_c('b',[_vm._v("Parcel Number :")]),_vm._v(_vm._s(_setup.building_plan_Details.parcel_no)+" ")]),_c('div',[_c('b',[_vm._v("Sub County :")]),_vm._v(_vm._s(_setup.returnSubCountyName(_setup.building_plan_Details.sub_county_id))+" ")]),_c('div',[_c('b',[_vm._v("Ward :")]),_vm._v(_vm._s(_setup.returnWardName(_setup.building_plan_Details.ward_id))+" ")]),_c('div',[_c('b',[_vm._v("Town :")]),_vm._v(_vm._s(_setup.returnTownName(_setup.building_plan_Details.town_name))+" ")]),_c('div',[_c('b',[_vm._v("Latitude :")]),_vm._v(_vm._s(_setup.building_plan_Details.latitude)+" ")]),_c('div',[_c('b',[_vm._v("Longitude :")]),_vm._v(_vm._s(_setup.building_plan_Details.longitude)+" ")])]),_c('v-col',{attrs:{"cols":"12","md":"5"}},[_c('div',[_c('b',[_vm._v("Cost of Building :")]),_vm._v(_vm._s(_setup.building_plan_Details.cost)+" ")]),_c('div',[_c('b',[_vm._v("Unit of Measure :")]),_vm._v(_vm._s(_setup.building_plan_Details.unit_of_measure)+" ")]),_c('div',[_c('b',[_vm._v("Plinth Area :")]),_vm._v(_vm._s(_setup.returnTotalPlinthAreas(_setup.building_plan_Details.plinth_area))+" ")]),_c('div',[_c('b',[_vm._v("Type of Development :")]),_vm._v(_vm._s(_setup.building_plan_Details.type_of_development_name)+" ")]),_c('div',[_c('b',[_vm._v("Number of Floors :")]),_vm._v(_vm._s(_setup.returnNumberOfFloors(_setup.building_plan_Details.number_of_floors))+" ")]),_c('div',[_c('b',[_vm._v("Physical Location/Landmark :")]),_vm._v(_vm._s(_setup.building_plan_Details.physical_address)+" ")])])],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"5"}},[_c('v-tabs',{attrs:{"show-arrows":""}},[_c('v-tabs-slider',{attrs:{"color":"secondary"}}),_c('v-tab',{staticClass:"text-none"},[_vm._v("Architect Details")])],1)],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c(_setup.Table,{attrs:{"headers":[
                            {
                                text: 'Architect Name',
                                value: 'customer_name',
                                fn: (architectsData) => architectsData.first_name ? architectsData.first_name + ' ' + architectsData.last_name : architectsData.organisation_name

                            },

                            {
                                text: 'Architect No',
                                value: 'architect_number',

                            },

                            {
                                text: 'Telephone No',
                                value: 'phone_number',

                            },

                            {
                                text: 'Email',
                                value: 'email_address',

                            },

                        ],"items":_setup.architect_arr_object,"emptyText":"No Architects Found","headClasses":"primary white--text"}})],1)],1)],1)],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"5"}},[_c('v-tabs',{attrs:{"show-arrows":""}},[_c('v-tabs-slider',{attrs:{"color":"secondary"}}),_c('v-tab',{staticClass:"text-none"},[_vm._v("Client Details")])],1)],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c(_setup.Table,{attrs:{"headers":[
                            {
                                text: 'Customer Name',
                                value: 'customer_name',

                            },

                            {
                                text: 'Phone No',
                                value: 'phone_number1',

                            },

                            {
                                text: 'ID No',
                                value: 'id_number',

                            },

                            {
                                text: 'Client Type',
                                value: 'client_type',


                            },

                        ],"items":_setup.client_arr_object,"emptyText":"No Clients Found","headClasses":"primary white--text"}})],1)],1)],1)],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"5"}},[_c('v-tabs',{attrs:{"show-arrows":""}},[_c('v-tabs-slider',{attrs:{"color":"secondary"}}),_c('v-tab',{staticClass:"text-none"},[_vm._v("Structural Engineer Details")])],1)],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c(_setup.Table,{attrs:{"headers":[
                            {
                                text: 'Structural Engineer Name',
                                value: 'customer_name',
                                fn: (structuralEngData) => structuralEngData.first_name ? structuralEngData.first_name + ' ' + structuralEngData.last_name : structuralEngData.organisation_name

                            },

                            {
                                text: 'Engineer No',
                                value: 'structural_engineer_number',

                            },

                            {
                                text: 'Telephone No',
                                value: 'phone_number',

                            },

                            {
                                text: 'Email',
                                value: 'email_address',

                            },

                        ],"items":_setup.structural_eng_arr_object,"emptyText":"No Structural Engineers Found","headClasses":"primary white--text"}})],1)],1)],1)],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"5"}},[_c('v-tabs',{attrs:{"show-arrows":""}},[_c('v-tabs-slider',{attrs:{"color":"secondary"}}),_c('v-tab',{staticClass:"text-none"},[_vm._v("Property Details")])],1)],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c(_setup.Table,{attrs:{"headers":[

                            {
                                text: 'Sub County',
                                value: 'sub_county',
                                fn: (item) => item.sub_county ? item.sub_county.sub_county_name : ''

                            },

                            {
                                text: 'Ward',
                                value: 'ward',
                                fn: (item) => item.ward ? item.ward.ward_name : ''

                            },

                            {
                                text: 'Town',
                                value: 'town',
                                fn: (item) => item.town ? item.town.town_name : ''

                            },


                            {
                                text: 'PRN No',
                                value: 'prn'

                            },

                            {
                                text: 'LR Number',
                                value: 'lr_no'

                            },


                            {
                                text: 'Block / Plot Number',
                                value: 'block_plot_no',
                                fn: (property) => (property.block_no || property.plot_no) ? property.block_no + '/' + property.plot_no : ''

                            },

                            {
                                text: 'Physical Location',
                                value: 'physical_location'

                            },

                        ],"items":_setup.property_arr_object,"emptyText":"No Properties Found","headClasses":"primary white--text"}})],1)],1)],1)],1)],1),_c('v-row',{attrs:{"justify-md":"end"}},[_c('v-col',{attrs:{"cols":"12","md":"auto"}},[_c('v-spacer'),_c('v-btn',{staticClass:"secondary text-none mt-3",attrs:{"depressed":""},on:{"click":function($event){return _setup.continueApplication()}}},[_vm._v(" Continue With Draft "),_c('v-icon',{attrs:{"right":""}},[_vm._v(" mdi-content-save ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }